export default [
  {
    path: '/a',
    name: 'admin',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/Admin.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'profile',
        name: 'admin.profile',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/settings/Profile.vue'
          )
      },
      {
        path: 'settings',
        name: 'admin.settings',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/settings/Settings.vue'
          )
      },
      {
        path: 'configuration',
        name: 'admin.configuration',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/settings/Configuration.vue'
          )
      },
      {
        path: 'dashboard',
        name: 'admin.dashboard',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/dashboard/Dashboard.vue'
          )
      },
      {
        path: 'notifications',
        name: 'admin.notifications',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/notifications/Notifications.vue'
          )
      },
      {
        path: 'products',
        name: 'admin.products',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/products/Products.vue'
          )
      },
      {
        path: 'my-chat',
        name: 'admin.my_chat',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/my-chat/MyChat.vue'
          )
      },
      {
        path: 'ecobanka-tv',
        name: 'admin.ecobanka_tv',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/ecobanka-tv/EcobankaTV.vue'
          )
      },
      {
        path: 'expired',
        name: 'admin.expired',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/dashboard/Expired.vue'
          )
      },
      {
        path: 'invitation-codes',
        name: 'admin.invitationCodes',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/invitation-codes/InvitationCodes.vue'
          )
      },
      {
        path: 'enumerates',
        name: 'admin.enumerates',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/enumerates/ListEnumerates.vue'
          )
      },
      {
        path: 'users',
        name: 'admin.users',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/users/Users.vue'
          ),
        children: [
          {
            path: 'list',
            name: 'admin.users.list',
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/users/ListUsers.vue'
              )
          },
          {
            path: 'new',
            name: 'admin.users.new',
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/users/NewUser.vue'
              )
          },
          {
            path: ':id',
            name: 'admin.users.update',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/users/UpdateUser.vue'
              )
          }
        ]
      },
      {
        path: 'onBoard',
        name: 'admin.onBoard',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/on-board/OnBoard.vue'
          ),
        children: [
          {
            path: 'list',
            name: 'admin.onBoard.list',
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/on-board/OnBoardRequestsList.vue'
              )
          },
          {
            path: ':id/detail',
            name: 'admin.on-board.detail',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/on-board/OnBoardRequestDetail.vue'
              )
          },
          {
            path: 'new',
            name: 'admin.on-board.new',
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/on-board/OnBoardRequestForm.vue'
              )
          }
        ]
      },
      {
        path: 'institutions',
        name: 'admin.institutions',
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            '@/views/admin/institutions/Institutions.vue'
          ),
        children: [
          {
            path: 'list',
            name: 'admin.institutions.list',
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/institutions/InstitutionsList.vue'
              ),
            meta: {
              title: 'Listado de instituciones'
            }
          },
          {
            path: 'new',
            name: 'admin.institutions.new',
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/institutions/InstitutionsForm.vue'
              ),
            meta: {
              title: 'Nueva institución'
            }
          },
          {
            path: ':id/edit',
            name: 'admin.institutions.edit',
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/institutions/InstitutionsForm.vue'
              ),
            meta: {
              title: 'Editar institución'
            }
          },
          {
            path: ':id/detail',
            name: 'admin.institutions.detail',
            component: () =>
              import(
                /* webpackChunkName: "admin" */
                '@/views/admin/institutions/InstitutionDetail.vue'
              ),
            meta: {
              title: 'Detalle institución'
            }
          }
        ]
      }
    ]
  }
]
